import React, { Component } from 'react';
import styled from 'astroturf/react';

import Timer from 'js/unibrows/seasonal_discount_unibrow/Timer';
import { currentUser } from 'js/utils/user';
import routes from 'js/core_pre_webpack/routes';
import { ImpressionWatcher } from 'js/utils/impressions';
import _Button from "CoralNewUserDiscountButton-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/CoralNewUserDiscountButton.tsx?styleId=Button";
import _ButtonText from "CoralNewUserDiscountButton-ButtonText.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/CoralNewUserDiscountButton.tsx?styleId=ButtonText";


type Props = {
  feature: string;
  trigger: string;
  couponCode: string;
};

type State = {
  startDuration: number;
};

const Button = /*#__PURE__*/styled("div", null, {
  displayName: "Button",
  styles: _Button
});

const ButtonText = /*#__PURE__*/styled("span", null, {
  displayName: "ButtonText",
  styles: _ButtonText
});

export default class CoralNewUserDiscountButton extends Component<
  Props,
  State
> {
  // SSR-safe: Use a fixed duration for SSR, update to actual duration on client
  state: State = {
    startDuration: 86400, // 24 hours in seconds as default for SSR
  };

  componentDidMount() {
    // Update to actual duration on client after mount
    if (currentUser?.created_at !== undefined) {
      const promotionEnd =
        Date.parse(currentUser.created_at) + 24 * 60 * 60 * 1000;
      const actualDuration = Math.floor((promotionEnd - Date.now()) / 1000);
      this.setState({ startDuration: actualDuration });
    }
  }

  checkoutUrl = () => {
    const { feature, trigger, couponCode } = this.props;

    return routes.checkout_url({
      feature,
      trigger,
      coupon_code: couponCode,
    });
  };

  render() {
    if (currentUser?.created_at === undefined) {
      return null;
    }

    return (
      <ImpressionWatcher source={this.props.trigger}>
        <Button as={'a'} href={this.checkoutUrl()}>
          <ButtonText blue>UPGRADE & GET 6 MONTHS FREE!</ButtonText>
          <Timer
            darkIndicator
            startDuration={this.state.startDuration}
            mini={true}
            style={{ paddingTop: 0 }}
          />
        </Button>
      </ImpressionWatcher>
    );
  }
}
